import { useEffect, useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fetchNewsletterStatus, sendNewsletterNow } from "@/lib/api";
import { errorMessage } from "@/lib/errorMessage";

export const NewsletterCard = ({ pass }) => {
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);

  const load = () =>
    fetchNewsletterStatus(pass)
      .then(setStatus)
      .catch(() => {});
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pass]);

  if (!status) return null;

  const sendNow = async () => {
    setSending(true);
    try {
      const r = await sendNewsletterNow(pass);
      if (r.skipped) toast.info(`Skipped: ${r.skipped}`);
      else toast.success(`Digest sent to ${r.sent}/${r.subscribers} subscribers.`);
      load();
    } catch (e) {
      toast.error(errorMessage(e, "Send failed."));
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="newsletter-card" className="mt-6 bg-white border border-[#E5E2DC] rounded-2xl p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-[240px] flex-1">
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold flex items-center gap-1.5">
            <Mail size={11} className="text-[#2B5339]" /> Weekly digest email
          </div>
          <p className="text-xs text-[#5C6B62] mt-1">
            Every Tuesday 2pm UTC, subscribers get the newest article + a calculator tip.
            {!status.configured && (
              <span className="text-[#C26747] font-medium"> Needs RESEND_API_KEY to send.</span>
            )}
          </p>
          <div className="text-[11px] text-[#1C2B23] mt-2 bg-[#F9F8F6] border border-[#E5E2DC] rounded-lg px-3 py-2">
            Next issue: <span className="font-medium">{status.next_content?.title}</span>
          </div>
        </div>
        <div className="text-right">
          <div data-testid="newsletter-subscriber-count" className="text-2xl font-medium text-[#2B5339]">
            {status.subscribers}
          </div>
          <div className="text-[10px] text-[#5C6B62] uppercase tracking-wider">subscribers</div>
          <button
            data-testid="newsletter-send-btn"
            type="button"
            disabled={sending || !status.configured}
            onClick={sendNow}
            className="mt-2 inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-[#1C2B23] text-white hover:bg-[#2B5339] disabled:opacity-40"
          >
            {sending ? <Loader2 size={11} className="animate-spin" /> : <Mail size={11} />}
            Send now
          </button>
        </div>
      </div>
      <div data-testid="newsletter-last-send" className="text-[10px] text-[#5C6B62] mt-3">
        {status.last_send
          ? `Last send ${new Date(status.last_send.run_at).toLocaleString()} — ${status.last_send.sent ?? 0} delivered${status.last_send.skipped ? ` · skipped: ${status.last_send.skipped}` : ""}`
          : "Never sent yet."}
      </div>
    </div>
  );
};
